/**
 * Local-part rules for tenant-configurable default email senders.
 *
 * The pattern is deliberately narrower than RFC 5322 (which permits quoted
 * strings and a wider punctuation set): every mainstream provider — and our
 * own SES/SendGrid send paths — treat anything outside this set as suspect,
 * and a tenant admin typing a sender name has no legitimate need for it.
 * 64 characters is the RFC limit for a local part.
 */
export const EMAIL_LOCAL_PART_PATTERN = /^[a-zA-Z0-9._+-]{1,64}$/;

/**
 * Local part used when a verified domain has no configured sender. Preserves
 * the historical behaviour of sending tenant email from `noreply@<domain>`.
 */
export const DEFAULT_EMAIL_LOCAL_PART = 'noreply';

/**
 * True when `value` is usable as the local part of a sending address.
 */
export function isValidEmailLocalPart(
	value: string | null | undefined,
): boolean {
	if (value == null) {
		return false;
	}

	return EMAIL_LOCAL_PART_PATTERN.test(value.trim());
}
